import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/components/dashboard/NeedsAttention.css';

const SPECIALITIES_API = 'https://7ivi6888a9.execute-api.eu-west-2.amazonaws.com/dev';

const NeedsAttention = () => {
  const { userAttributes, userProfileSlug } = useAuth();
  const userSub = userAttributes?.sub;
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const refresh = () => setAttempt((value) => value + 1);
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, []);

  useEffect(() => {
    if (!userSub) return;
    const controller = new AbortController();
    setResult(null);

    const load = async () => {
      try {
        const response = await fetch(`${SPECIALITIES_API}/photographers/${encodeURIComponent(userSub)}/specialities`, {
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Specialities request failed (${response.status})`);
        const specialities = await response.json();
        if (!Array.isArray(specialities)) throw new Error('Invalid specialities response');
        const hasSpecialities = specialities.some((item) => typeof item?.speciality === 'string' && item.speciality.trim());
        if (!controller.signal.aborted) setResult({ userSub, state: hasSpecialities ? 'complete' : 'missing' });
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error('Could not check photography specialities:', error);
          setResult({ userSub, state: 'error' });
        }
      }
    };

    load();
    return () => controller.abort();
  }, [userSub, attempt]);

  const state = result?.userSub === userSub ? result?.state : null;

  return (
    <section className="needs-attention" aria-labelledby="needs-attention-title">
      <h2 id="needs-attention-title">Needs attention</h2>
      {!state && <p role="status">Checking your profile…</p>}
      {state === 'error' && (
        <div role="alert">
          <p>We could not check your specialities.</p>
          <button type="button" onClick={() => setAttempt((value) => value + 1)}>Try again</button>
        </div>
      )}
      {state === 'missing' && (
        <div>
          <p>Add your photography specialities so clients know what you offer.</p>
          {userProfileSlug ? (
            <Link to={`/profile/${encodeURIComponent(userProfileSlug)}?edit=specialities`}>Add specialities</Link>
          ) : <p>Open Your profile and choose Edit Profile to add your specialities.</p>}
        </div>
      )}
      {state === 'complete' && <p>You're all caught up.</p>}
    </section>
  );
};

export default NeedsAttention;
